import { React, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

import api from "../../../api/api";

const CompanyEditModal = ({ companyListId, setChanges, changes, companyType=null }) => {

 
  const [companyList, setCompanyList] = useState({});
  const { register, handleSubmit, setValue } = useForm();


  const handleSub = (data) => {

    api
      .patch(`/services/company/${companyListId}/`, data)
      .then((respone) => {
        setChanges(!changes)
        toast.success("Data updated successfully");
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  };


  useEffect(() => {
    if(companyListId !== null){
    api
      .get(`/services/company/?id=${companyListId}`)
      .then((response) => {
        setCompanyList(response.data[0]);
      })
      .catch((error) => {
        // toast.error("Something Went Wrong")
        console.log(error);
      });
    }
  }, [companyListId]);
  // const listOfCompany=companyList.map((item)=>())
  // console.log("Company List", companyList);
  return (
    <div
      className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
      id="LinkModalDemo"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-modal="true"
      role="dialog"
    >
      <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
        <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
          <div className="flex justify-end">
            <svg
              data-bs-dismiss="modal"
              aria-label="Close"
              className="text-primary-blue h-8 w-8"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              role="img"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
              />
            </svg>
          </div>
          <h1 className="text-center text-primary-red font-Calistoga text-2xl mb-5 underline">
            Company Details
          </h1>

          <form onSubmit={handleSubmit(handleSub)} className="m-2">

            <div className="grid grid-cols-1 border-2 font-semibold border-primary-blue md:grid-cols-2  mx-3 font-Laila">
              <div className="border-b md:border-r border-primary-blue p-2">
                <label htmlFor="">कम्पनी दर्ता नं :</label>
                <input
                  type="text"
                  className="pl-2 ml-2 outline-none  w-36 md:w-60 font-Calistoga text-primary-blue"
                  {...register(
                    "regd_number",
                    { required: true },
                    setValue("regd_number", companyList.regd_number)
                  )}
                />
              </div>
              <div className="border-b  border-primary-blue p-2">
                <label htmlFor="">कम्पनी दर्ता मिती :</label>
                <input
                  type="text"
                  className="pl-2 ml-2 outline-none w-32 md:w-60 font-Calistoga text-primary-blue"
                  {...register(
                    "regd_date",
                    { required: true },
                    setValue("regd_date", companyList.regd_date)
                  )}
                />
              </div>

              <div className="border-b md:border-r border-primary-blue p-2">
                <label htmlFor="">कम्पनको नाम :</label>
                <input
                  type="text"
                  placeholder="अंग्रेजीमा"
                  {...register(
                    "company_name",
                    { required: true },
                    setValue("company_name", companyList.company_name)
                  )}
                  className="pl-2 ml-2 outline-none w-36 md:w-60 font-Calistoga text-primary-blue"
                />
              </div>

              <div className="border-b  border-primary-blue p-2">
                <label htmlFor="">कम्पको नाम :</label>
                <input
                  type="text"
                  placeholder="नेपालीमा"
                  {...register(
                    "company_name_nep",
                    { required: true },
                    setValue("company_name_nep", companyList.company_name_nep)
                  )}
                  className="pl-2 ml-2 outline-none w-36 md:w-60 font-Calistoga text-primary-blue"
                />
              </div>
              <div className="border-b md:border-r border-primary-blue p-2">
                <label htmlFor="">कम्पनीको ठेगाना:</label>
                <input
                  type="text"
                  className="pl-2 ml-2 outline-none w-32 md:w-60 font-Calistoga text-primary-blue"
                  {...register(
                    "company_address",
                    { required: true },
                    setValue("company_address", companyList.company_address)
                  )}
                />
              </div>
              <div className="border-b  border-primary-blue p-2">
                <label htmlFor="">कम्पनीको प्रकार :</label>

                {companyList.business_type === "ekal" ? (
                  <>
                    <input
                      {...register(
                        "business_type",
                        { required: true },
                        setValue("business_type", "ekal")
                      )}
                      type="radio"
                      id="ekal"
                      name="company_type"
                      checked={true}
                      className="pl-2 mx-2 outline-none   font-Calistoga text-primary-blue"
                    />

                    <label htmlFor="ekal">एकल</label>
                    <input
                      type="radio"
                      id="typebahul"
                      {...register(
                        "business_type",
                        { required: true },
                        setValue("business_type", "bahul")
                      )}
                      name="company_type"
                      className="pl-2 mx-2 outline-none   font-Calistoga text-primary-blue"
                    />
                    <label htmlFor="typebahul">बहुल</label>
                  </>
                ) : (
                  <>
                    <input
                      type="radio"
                      id="typeekal"
                      checked={true}
                      {...register(
                        "business_type",
                        { required: true },
                        setValue("business_type", "ekal")
                      )}
                      name="company_type"
                      className="pl-2 mx-2 outline-none   font-Calistoga text-primary-blue"
                    />
                    <label htmlFor="typebahul">एकल</label>
                    
                    <input
                      {...register(
                        "business_type",
                        { required: true },
                        setValue("business_type", "bahul")
                      )}
                      type="radio"
                      id="bahul"
                      name="company_type"
                      className="pl-2 mx-2 outline-none   font-Calistoga text-primary-blue"
                    />

                    <label htmlFor="ekal">बहुल</label>
                  
                  </>
                )}
              </div>
              <div className="border-b md:border-r font-Calistoga border-primary-blue p-2">
                <label htmlFor="">PAN No:</label>
                <input
                  type="text"
                  className="pl-2 ml-2 outline-none w-36 md:w-60 font-Calistoga text-primary-blue"
                  {...register(
                    "company_pan",
                    { required: true },
                    setValue("company_pan", companyList.company_pan)
                  )}
                />
              </div>
              <div className="border-b flex flex-wrap font-Calistoga  border-primary-blue p-2">
                <label htmlFor="">Tax Type :</label>
                <div>
                  <input
                    type="checkbox"
                    id="pan"
                    name="tax-type"
                    className="pl-2 ml-2 outline-none mx-2 font-Calistoga text-primary-blue"
                  />
                  <label htmlFor="pan">Pan</label>
                  <input
                    type="checkbox"
                    id="vat"
                    name="tax-type"
                    className="pl-2 ml-2 outline-none mx-2 font-Calistoga text-primary-blue"
                  />
                  <label htmlFor="vat">VAT ,</label>
                </div>
                <div className="">
                  <label htmlFor="">(Entry :</label>
                  <input
                    type="checkbox"
                    id="self"
                    name="tax-type"
                    className="pl-2 ml-2 outline-none mx-2 font-Calistoga text-primary-blue"
                  />
                  <label htmlFor="self">Self</label>
                  <input
                    type="checkbox"
                    id="office"
                    name="tax-type"
                    className="pl-2 ml-2 outline-none mx-2 font-Calistoga text-primary-blue"
                  />
                  <label htmlFor="office">Office)</label>
                </div>
              </div>

              <div className="border-b flex font-Calistoga flex-wrap md:border-b-0 md:border-r border-primary-blue p-2">
                <label htmlFor="">Contact Person Name :</label>
                <input
                  type="text"
                  {...register(
                    "contact_person",
                    { required: true },
                    setValue("contact_person", companyList.contact_person)
                  )}
                  className="pl-2 ml-2 outline-none w-36  md:w-40 font-Calistoga text-primary-blue"
                />
              </div>
              <div className="font-Calistoga border-primary-blue p-2">
                <label htmlFor="">Contact No :</label>
                <input
                  type="text"
                  {...register(
                    "conatact_number",
                    { required: true },
                    setValue("conatact_number", companyList.conatact_number)
                  )}
                  className="pl-2 ml-2 w-36 md:w-60 outline-none font-Calistoga text-primary-blue"
                />
              </div>
            </div>
            <div className="border-b-2 border-x-2 text-center flex flex-wrap border-primary-blue p-2 mx-3">
              <label htmlFor="">Company Type : </label>
              
              <p> &nbsp;{companyType}</p>

              {/* <input
                type="checkbox"
                id="newcompany"
                name="tax-type"
                {...register(
                  "conatact_number",
                  { required: true },
                  setValue("conatact_number", companyList.conatact_number)
                )}
                className="pl-2 ml-2 outline-none mx-2 font-Calistoga text-primary-blue"
              /> */}
              {/* <label htmlFor="newcompany">New Company</label>
              <input
                type="checkbox"
                id="oldcompany"
                name="tax-type"
                // company_type
                {...register(
                  "conatact_number",
                  { required: true },
                  setValue("conatact_number", companyList.conatact_number)
                )}
                className="pl-2 ml-2 outline-none mx-2 font-Calistoga text-primary-blue"
              />
              <label htmlFor="oldcompany">Old Company</label>
              <input
                type="checkbox"
                id="other"
                checked
                name="tax-type"
                className="pl-2 ml-2 outline-none mx-2 font-Calistoga text-primary-blue"
              />
              <label htmlFor="other">Other Bussiness</label> */}
            </div>
            <div className="mx-5 mb-5 mt-2  ">
              <input
                className="bg-primary-red  text-white float-right rounded-full px-3 cursor-pointer "
                type="submit"
                value="Submit"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
                {/* Submit1
              </button> */}
            </div>
          </form>
          {/* <h1 className='text-center text-primary-red font-Calistoga text-2xl mb-5 underline'>Use For Social Media</h1> */}

          {/* <div className=' border-2 border-primary-blue m-5 grid grid-cols-1 md:grid-cols-2 '>
            <div className='border-b md:border-r border-primary-blue p-2'>
              <label htmlFor="">Email :</label>
              <input type="text" className=' ml-3 pl-2 outline-none ' />
            </div >
            <div className='border-b  border-primary-blue p-2'>
              <label htmlFor="">Messenger Link </label>
              <input type="text"   className=' ml-3 pl-2 outline-none ' />
            </div>
            <div className='border-b  md:border-b-0 md:border-r border-primary-blue p-2'>
              <label htmlFor="">Viber</label>
              <input type="text"  className=' ml-3 pl-2 outline-none '/>
            </div>
            <div className=' p-2'>
              <label htmlFor="">Whatsapp</label>
              <input type="text"  className=' ml-3 pl-2 outline-none '/>
            </div>

          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CompanyEditModal;
